import { render, staticRenderFns } from "./PostInstagram.vue?vue&type=template&id=3c5d5ea6"
import script from "./PostInstagram.vue?vue&type=script&lang=js"
export * from "./PostInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5d5ea6')) {
      api.createRecord('3c5d5ea6', component.options)
    } else {
      api.reload('3c5d5ea6', component.options)
    }
    module.hot.accept("./PostInstagram.vue?vue&type=template&id=3c5d5ea6", function () {
      api.rerender('3c5d5ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/PostInstagram.vue"
export default component.exports